export const pageLimit = 9;

export const body = document.querySelector('body');

export const companyId = document.querySelector('.company-jobs') ? document.querySelector('.company-jobs').dataset.id : '';

export const categoryId = document.querySelector('.js-categories-page') ? document.querySelector('.js-categories-page').dataset.categoryId : '';

export const industryId = document.querySelector('.js-industries-page') ? document.querySelector('.js-industries-page').dataset.industryId : '';

export const links = document.querySelector('.jobs-data').dataset.links ? JSON.parse(document.querySelector('.jobs-data').dataset.links) : '';

export const filters = document.querySelector('[data-filters]') ? JSON.parse(document.querySelector('[data-filters]').dataset.filters) : '';

export const rootUrl = document.querySelector('[data-root-url]') ? document.querySelector('[data-root-url]').dataset.rootUrl : '';

export const param = document.querySelector('.industry-jobs') ? document.querySelector('.industry-jobs').dataset.param : '';

export const scrollToEl = document.querySelector('.js-scrollto-element');

export const locale = window.location.pathname.substring(1, 3);

export const token = document.querySelector('meta[name=\'csrf-token\']') ? document.querySelector('meta[name=\'csrf-token\']').getAttribute('content') : '';